import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';
const IconPhoto = t0 => {
  const $ = _c(7);
  const {
    color: t1,
    width: t2,
    height: t3,
    className: t4
  } = t0;
  const color = t1 === undefined ? colorGray : t1;
  const width = t2 === undefined ? "24" : t2;
  const height = t3 === undefined ? "24" : t3;
  const className = t4 === undefined ? "" : t4;
  let t5;
  if ($[0] !== color) {
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M2.747 19.944H20.543C21.9222 19.944 23.04 18.8262 23.04 17.447V6.747C23.04 5.36779 21.9222 4.25 20.543 4.25H2.747C1.36779 4.25 0.25 5.36779 0.25 6.747V17.447C0.25 18.8262 1.36779 19.944 2.747 19.944ZM21.54 17.447C21.54 17.9978 21.0938 18.444 20.543 18.444H2.747C2.19621 18.444 1.75 17.9978 1.75 17.447V6.747C1.75 6.19621 2.19621 5.75 2.747 5.75H20.543C21.0938 5.75 21.54 6.19621 21.54 6.747V17.447ZM10.9893 16.6208C13.6125 16.6208 15.7393 14.494 15.7393 11.8708C15.7393 9.24759 13.6125 7.1208 10.9893 7.1208C8.36609 7.1208 6.2393 9.24759 6.2393 11.8708C6.2393 14.494 8.36609 16.6208 10.9893 16.6208ZM10.9893 8.6208C12.7841 8.6208 14.2393 10.076 14.2393 11.8708C14.2393 13.6656 12.7841 15.1208 10.9893 15.1208C9.19451 15.1208 7.7393 13.6656 7.7393 11.8708C7.7393 10.076 9.19451 8.6208 10.9893 8.6208ZM19.4401 8.6208H17.5381V7.1208H19.4401V8.6208Z" fill={color} />;
    $[0] = color;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== className || $[3] !== height || $[4] !== t5 || $[5] !== width) {
    t6 = <svg viewBox="0 0 24 24" fill="none" width={width} height={height} className={className}>{t5}</svg>;
    $[2] = className;
    $[3] = height;
    $[4] = t5;
    $[5] = width;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
IconPhoto.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};
export default IconPhoto;